import { useMemo } from 'react'

import { MediaTypes, SocialSubmissionTypes, SubmissionChannels } from '@enums'
import { IPrePurchaseBrandConnectAnalytics } from '@store/prePurchaseAnalytics'
import { IAnalyticsBreakdownFilterProps } from './Filter/AnalyticsBreakdownFilter'
import { AnalyticsBrandConnectBreakdown } from './BrandConnectBreakdown'
import { MetricEntry } from './types'
import { usePrePurchaseBrandConnectMetricBreakdown } from './useAnalyticsBreakdown'

type Props = {
  analytics: IPrePurchaseBrandConnectAnalytics[]
  socialSubmissionType: SocialSubmissionTypes
  currency: string
  isLoaded: boolean
  isProxy?: boolean
  channel?: SubmissionChannels
  mediaType?: MediaTypes
} & IAnalyticsBreakdownFilterProps

export const AnalyticsBrandConnectPrePurchaseBreakdown: React.FC<Props> = ({
  analytics,
  filters,
  ...props
}) => {
  const filteredAnalytics = useMemo(() => {
    const filterEntries = Object.entries(filters || {})

    if (filterEntries.length === 0) {
      return analytics
    }

    return analytics.filter((a) =>
      filterEntries.every(
        ([key, filter]) =>
          a[key as keyof IPrePurchaseBrandConnectAnalytics] === filter.selected.value,
      ),
    )
  }, [analytics, filters])

  const analyticsData = filteredAnalytics.length > 0 ? filteredAnalytics[0] : {}

  const { overview, viewerPerformance, engagement } = usePrePurchaseBrandConnectMetricBreakdown(
    analyticsData,
  )

  const manualGlossaryEntries: MetricEntry[] = [
    { metric: 'audience_age', source: 'youtube_brand_connectV2', value: 0 },
    { metric: 'audience_gender', source: 'youtube_brand_connectV2', value: 0 },
    { metric: 'audience_location', source: 'youtube_brand_connectV2', value: 0 },
    { metric: 'affinity_interest', source: 'youtube_brand_connectV2', value: 0 },
    { metric: 'in_market_interest', source: 'youtube_brand_connectV2', value: 0 },
  ]

  return (
    <AnalyticsBrandConnectBreakdown
      {...props}
      analytics={analytics}
      filters={filters}
      sections={[
        { title: 'overview', entries: overview },
        { title: 'viewerPerformance', entries: viewerPerformance },
        { title: 'engagementBreakdown', entries: engagement },
      ]}
      customGlossaryEntries={manualGlossaryEntries}
    />
  )
}
